module.exports = __webpack_public_path__ + "static/img/gongan.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/gongan.png
// module id = bE1W
// module chunks = 1